var moment = require('moment');

var dateFormat = 'MM/DD/YYYY';

function formatCalibrationDue(value) {
  var dueDate;

  if (value === null || typeof value === 'undefined') {
    return 'Pending';
  }

  if (typeof value === 'string') {
    value = value.trim();
    if (!value || value.toLowerCase() === 'pending') {
      return 'Pending';
    }
    dueDate = /^-?\d+(\.\d+)?$/.test(value)
      ? moment(Number(value))
      : moment(value, moment.ISO_8601, true);
  } else {
    dueDate = moment(value);
  }

  return dueDate.isValid() ? dueDate.format(dateFormat) : 'Pending';
}

module.exports = formatCalibrationDue;
